<template>
    <div v-once class="spinner-wrapper">
        <div class="spinner"></div>
    </div>
</template>
  
<style scoped lang="scss">
@use '~theme' as *;
.spinner-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.spinner {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 5px solid rgba($pallete-3, 0.1);
    border-radius: 50%;
    border-top-color: $pallete-3;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>
